import {Component} from '@angular/core';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import {ModalKendo} from '../../lib/ModalKendo';
import {KendoPopupUtils} from '../../lib/KendoPopupUtils';
import {EstoqueService} from '../../services/estoque.service';
import {
  CadVinculoFornecimentoItemComponent
} from '../cad-vinculo-fornecimento-item/cad-vinculo-fornecimento-item.component';

@Component({
  selector: 'app-cad-apresentacao-compra',
  templateUrl: './cad-apresentacao-compra.component.html',
  styleUrls: ['./cad-apresentacao-compra.component.scss']
})
export class CadApresentacaoCompraComponent extends ModalKendo {
  apresentacao: any = {};
  unidadeBaseFixa: any;
  unidades: any[] = [];
  tiposEmbalagem: any[] = [];
  grupos: any[] = [];
  vinculos: any[] = [];
  candidatos: any[] = [];
  insumosDisponiveis: any[] = [];
  gruposFiltro: any[] = [];
  idsInsumosSelecionados: number[] = [];
  abaSelecionada = 0;
  adicionandoVinculos = false;
  carregandoVinculos = false;
  carregandoCandidatos = false;
  salvandoVinculos = false;
  termoInsumo = '';
  grupoFiltroId: any = null;
  exibirIncompativeis = false;
  fornecimentoConfigurado = false;
  mensagemErroVinculos: string;
  mensagemSucessoVinculos: string;
  carregando = false;
  salvando = false;
  mensagemErro: string;
  private timerBusca: any;

  constructor(
    private estoqueService: EstoqueService,
    private dialogService: DialogService
  ) {
    super();
  }

  static abraModal(
    dialogService: DialogService,
    apresentacao: any = null,
    unidadeBaseFixa: any = null,
    abaInicial = 0,
    grupos: any[] = []
  ): DialogRef {
    const windowRef: DialogRef = dialogService.open({
      content: CadApresentacaoCompraComponent,
      minWidth: 250,
      width: Math.min(980, Math.max(250, window.innerWidth - 30)),
      cssClass: 'bsModal',
      maxHeight: window.innerHeight - 100
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);
    windowRef.content.instance.inicialize(
      apresentacao,
      unidadeBaseFixa,
      abaInicial,
      grupos
    );
    return windowRef;
  }

  inicialize(
    apresentacao: any = null,
    unidadeBaseFixa: any = null,
    abaInicial = 0,
    grupos: any[] = []
  ): void {
    this.unidadeBaseFixa = unidadeBaseFixa;
    this.abaSelecionada = abaInicial;
    this.grupos = grupos || [];
    this.apresentacao = apresentacao
      ? Object.assign({}, apresentacao, {
          fatorConversao: apresentacao.fatorConversao == null
            ? null
            : Number(apresentacao.fatorConversao)
        })
      : {
          unidadeBase: unidadeBaseFixa || null,
          tipoEmbalagem: null,
          descricao: '',
          fatorConversao: null,
          ativa: true,
          totalVinculos: 0,
          totalVinculosAtivos: 0
        };
    this.carregueOpcoes();
    if(this.apresentacao.id)
      this.carregueVinculos();
  }

  onSalvar(): void {
    if(this.salvando || !this.apresentacaoValida())
      return;

    this.salvando = true;
    this.mensagemErro = null;
    this.estoqueService.salveApresentacaoCompraGlobal(this.apresentacao)
      .then((salva: any) => {
        this.salvando = false;
        this.fecheModal(salva);
      }).catch((erro: any) => {
        this.mensagemErro = erro;
        this.salvando = false;
      });
  }

  apresentacaoValida(): boolean {
    const fator = Number(this.apresentacao && this.apresentacao.fatorConversao);
    const descricao = String(this.apresentacao && this.apresentacao.descricao || '').trim();
    return !!this.apresentacao && !!this.apresentacao.unidadeBase &&
      !!this.apresentacao.unidadeBase.id && !!this.apresentacao.tipoEmbalagem &&
      !!this.apresentacao.tipoEmbalagem.id && !!descricao && descricao.length <= 120 &&
      Number.isFinite(fator) && fator > 0;
  }

  unidadeBaseBloqueada(): boolean {
    return !!this.unidadeBaseFixa || Number(this.apresentacao.totalVinculos) > 0;
  }

  selecioneAba(evento: any): void {
    this.abaSelecionada = evento.index;
    if(this.abaSelecionada === 1 && this.apresentacao.id && !this.carregandoVinculos)
      this.carregueVinculos();
  }

  carregueVinculos(): void {
    if(!this.apresentacao.id)
      return;
    this.carregandoVinculos = true;
    this.mensagemErroVinculos = null;
    Promise.all([
      this.estoqueService.listeVinculosDaApresentacao(Number(this.apresentacao.id)),
      this.estoqueService.obtenhaCatalogoComprasInternas()
    ]).then((resultados: any[]) => {
        this.vinculos = resultados[0] || [];
        this.fornecimentoConfigurado = !!(resultados[1] && resultados[1].fornecimento);
        this.apliqueCorrespondencias(resultados[1]);
        this.apresentacao.totalVinculos = this.vinculos.length;
        this.apresentacao.totalVinculosAtivos = this.vinculos
          .filter(item => item.ativa).length;
        this.carregandoVinculos = false;
      }).catch((erro: any) => {
        this.mensagemErroVinculos = erro;
        this.carregandoVinculos = false;
      });
  }

  configureDePara(vinculo: any): void {
    const windowRef = CadVinculoFornecimentoItemComponent.abraModal(
      this.dialogService,
      vinculo,
      vinculo.insumo
    );
    windowRef.result.subscribe((resultado: any) => {
      if(resultado && resultado.alterado)
        this.carregueVinculos();
    });
  }

  rotuloCorrespondencia(vinculo: any): string {
    if(!vinculo.ativa)
      return 'Removido';
    const status = vinculo.correspondencia && vinculo.correspondencia.status;
    return {
      VINCULADO: 'Vinculado',
      PENDENTE: 'Pendente',
      AMBIGUO: 'Ambíguo',
      INCOMPATIVEL: 'Incompatível'
    }[status] || 'Pendente';
  }

  classeCorrespondencia(vinculo: any): string {
    if(!vinculo.ativa)
      return 'badge-secondary';
    const status = vinculo.correspondencia && vinculo.correspondencia.status;
    return {
      VINCULADO: 'badge-success',
      PENDENTE: 'badge-warning',
      AMBIGUO: 'badge-info',
      INCOMPATIVEL: 'badge-danger'
    }[status] || 'badge-warning';
  }

  abraAdicaoVinculos(): void {
    this.adicionandoVinculos = true;
    this.idsInsumosSelecionados = [];
    this.termoInsumo = '';
    this.grupoFiltroId = null;
    this.exibirIncompativeis = false;
    this.mensagemErroVinculos = null;
    this.mensagemSucessoVinculos = null;
    this.carregueInsumosDisponiveis();
  }

  volteParaVinculos(): void {
    if(!this.salvandoVinculos){
      this.adicionandoVinculos = false;
      this.idsInsumosSelecionados = [];
    }
  }

  carregueCandidatos(): void {
    const termo = String(this.termoInsumo || '').trim().toLocaleLowerCase();
    const grupoId = this.grupoFiltroId === null || this.grupoFiltroId === ''
      ? null
      : Number(this.grupoFiltroId);
    this.candidatos = this.insumosDisponiveis.filter((insumo: any) => {
      const correspondeAoTermo = !termo ||
        String(insumo.nome || '').toLocaleLowerCase().includes(termo) ||
        String(insumo.codigo || '').toLocaleLowerCase().includes(termo);
      const idGrupoInsumo = insumo.grupo && insumo.grupo.id
        ? Number(insumo.grupo.id)
        : 0;
      const correspondeAoGrupo = grupoId === null || idGrupoInsumo === grupoId;
      const correspondeACompatibilidade = this.exibirIncompativeis || insumo.compativel;
      return !insumo.vinculado && correspondeACompatibilidade &&
        correspondeAoTermo && correspondeAoGrupo;
    });
    this.idsInsumosSelecionados = [];
  }

  onFilterInsumos(evento: any): void {
    if(this.timerBusca)
      clearTimeout(this.timerBusca);
    this.termoInsumo = evento.target.value;
    this.timerBusca = setTimeout(() => this.carregueCandidatos(), 1000);
  }

  onSelectedKeysChange(ids: number[]): void {
    const idsValidos = (ids || []).filter(id => {
      const insumo = this.insumosDisponiveis.find(item => Number(item.id) === Number(id));
      return insumo && insumo.compativel && !insumo.vinculado && insumo.disponivelParaVinculo;
    });
    if(idsValidos.length !== ids.length)
      setTimeout(() => this.idsInsumosSelecionados = idsValidos);
  }

  salveNovosVinculos(): void {
    if(this.salvandoVinculos || !this.idsInsumosSelecionados.length)
      return;
    const idsSelecionados = this.idsInsumosSelecionados.map(id => Number(id));
    const insumosSelecionados = this.insumosDisponiveis.filter(insumo =>
      idsSelecionados.includes(Number(insumo.id))
    );
    this.salvandoVinculos = true;
    this.mensagemErroVinculos = null;
    this.estoqueService.vinculeApresentacaoEmLote(
      Number(this.apresentacao.id),
      idsSelecionados,
      false
    ).then((resultado: any) => {
      this.salvandoVinculos = false;
      this.adicionandoVinculos = false;
      this.idsInsumosSelecionados = [];
      this.mensagemSucessoVinculos =
        `${resultado.quantidade} insumo(s) vinculado(s) com sucesso.`;
      this.carregueVinculos();
    }).catch((erro: any) => {
      const mensagem = this.detalheErroDeInsumosNaoEncontrados(
        erro,
        insumosSelecionados
      );
      this.salvandoVinculos = false;
      if(mensagem !== erro)
        this.carregueInsumosDisponiveis(mensagem);
      else
        this.mensagemErroVinculos = erro;
    });
  }

  removaVinculo(evento: any): void {
    const vinculo = evento.dataItem;
    if(vinculo.salvando)
      return;
    vinculo.salvando = true;
    this.mensagemErroVinculos = null;
    this.estoqueService.removaVinculoApresentacaoCompra(
      Number(vinculo.insumo.id),
      Number(vinculo.id)
    ).then(() => {
      this.vinculos = this.vinculos.filter(item => Number(item.id) !== Number(vinculo.id));
      this.apresentacao.totalVinculos = this.vinculos.length;
      this.apresentacao.totalVinculosAtivos = this.vinculos.filter(item => item.ativa).length;
      this.mensagemSucessoVinculos = 'Vínculo removido com sucesso.';
    }).catch((erro: any) => {
      vinculo.salvando = false;
      this.mensagemErroVinculos = erro;
    });
  }

  restaureVinculo(vinculo: any): void {
    this.altereSituacaoVinculo(vinculo, true);
  }

  feche(): void {
    this.fecheModal(this.apresentacao && this.apresentacao.id ? this.apresentacao : null);
  }

  formateFator(valor: any): string {
    const numero = Number(valor);
    return Number.isFinite(numero)
      ? numero.toLocaleString('pt-BR', {maximumFractionDigits: 6})
      : '';
  }

  private carregueOpcoes(): void {
    this.carregando = true;
    this.mensagemErro = null;
    Promise.all([
      this.estoqueService.listeTiposEmbalagem(),
      this.estoqueService.listeUnidades()
    ]).then((resultados: any[]) => {
      this.tiposEmbalagem = resultados[0] || [];
      this.unidades = resultados[1] || [];
      this.normalizeOpcoesSelecionadas();
      this.carregando = false;
    }).catch((erro: any) => {
      this.mensagemErro = erro;
      this.carregando = false;
    });
  }

  private normalizeOpcoesSelecionadas(): void {
    const unidadeAtual = this.unidadeBaseFixa || this.apresentacao.unidadeBase;
    if(unidadeAtual){
      this.apresentacao.unidadeBase = this.unidades.find(
        unidade => Number(unidade.id) === Number(unidadeAtual.id)
      ) || unidadeAtual;
    }

    const tipoAtual = this.apresentacao.tipoEmbalagem;
    if(tipoAtual){
      const tipoCadastrado = this.tiposEmbalagem.find(
        tipo => Number(tipo.id) === Number(tipoAtual.id)
      );
      if(tipoCadastrado)
        this.apresentacao.tipoEmbalagem = tipoCadastrado;
      else
        this.tiposEmbalagem = this.tiposEmbalagem.concat([tipoAtual]);
    }
  }

  private altereSituacaoVinculo(vinculo: any, ativa: boolean): void {
    if(vinculo.salvando)
      return;
    vinculo.salvando = true;
    this.mensagemErroVinculos = null;
    this.estoqueService.salveApresentacaoCompra(Number(vinculo.insumo.id), {
      id: vinculo.id,
      ativa,
      padrao: ativa ? !!vinculo.padrao : false
    }).then(() => {
      vinculo.salvando = false;
      vinculo.ativa = ativa;
      if(!ativa)
        vinculo.padrao = false;
      this.apresentacao.totalVinculosAtivos = this.vinculos
        .filter(item => item.ativa).length;
      this.mensagemSucessoVinculos = ativa
        ? 'Vínculo restaurado com sucesso.'
        : 'Vínculo removido com sucesso.';
      this.carregueVinculos();
    }).catch((erro: any) => {
      vinculo.salvando = false;
      this.mensagemErroVinculos = erro;
    });
  }

  private carregueInsumosDisponiveis(mensagemAposAtualizar: string = null): void {
    this.carregandoCandidatos = true;
    this.mensagemErroVinculos = null;
    Promise.all([
      this.estoqueService.listeInsumos(0, 500, {comEstoque: true}),
      this.estoqueService.listeInsumosCandidatosApresentacao(Number(this.apresentacao.id))
    ]).then((resultados: any[]) => {
        const insumos: any[] = resultados[0] || [];
        const idsDisponiveis = new Set((resultados[1] || []).map((insumo: any) =>
          Number(insumo.id)
        ));
        const idsVinculados = new Set(this.vinculos.map(item =>
          Number(item.insumo && item.insumo.id)
        ));
        this.insumosDisponiveis = (insumos || [])
          .filter((insumo: any) => insumo.objeto !== 'ficha-tecnica' && !!insumo.estoque)
          .map((insumo: any) => Object.assign({}, insumo, {
            compativel: idsDisponiveis.has(Number(insumo.id)),
            vinculado: idsVinculados.has(Number(insumo.id)),
            disponivelParaVinculo: idsDisponiveis.has(Number(insumo.id))
          }));
        this.gruposFiltro = this.monteGruposFiltro(this.insumosDisponiveis);
        this.carregandoCandidatos = false;
        this.carregueCandidatos();
        this.mensagemErroVinculos = mensagemAposAtualizar;
      }).catch((erro: any) => {
        this.mensagemErroVinculos = erro;
        this.carregandoCandidatos = false;
      });
  }

  private detalheErroDeInsumosNaoEncontrados(erro: any, insumosSelecionados: any[]): string {
    const mensagem = String(erro || '');
    const correspondencia = mensagem.match(/IDs:\s*([0-9,\s]+)/i);
    if(!correspondencia)
      return erro;

    const idsNaoEncontrados = correspondencia[1].split(',')
      .map(id => Number(id.trim()))
      .filter(id => Number.isInteger(id) && id > 0);
    const descricao = idsNaoEncontrados.map(id => {
      const insumo = (insumosSelecionados || []).find(item => Number(item.id) === id);
      return insumo ? `${insumo.nome} (ID ${id})` : `ID ${id}`;
    }).join(', ');
    return `Insumo(s) não encontrado(s) para esta empresa: ${descricao}. ` +
      'A lista foi atualizada; selecione novamente.';
  }

  private monteGruposFiltro(insumos: any[]): any[] {
    const gruposPorId = new Map<number, any>();
    (this.grupos || []).forEach((grupo: any) => {
      if(Number(grupo && grupo.id) > 0)
        gruposPorId.set(Number(grupo.id), grupo);
    });
    insumos.forEach((insumo: any) => {
      const grupo = insumo && insumo.grupo;
      if(Number(grupo && grupo.id) > 0)
        gruposPorId.set(Number(grupo.id), grupo);
    });
    return Array.from(gruposPorId.values()).sort((a: any, b: any) =>
      String(a.nome || '').localeCompare(String(b.nome || ''))
    );
  }

  private apliqueCorrespondencias(catalogo: any): void {
    const porApresentacao = new Map<number, any>();
    ((catalogo && catalogo.insumos) || []).forEach((item: any) =>
      (item.apresentacoes || []).forEach((apresentacao: any) =>
        porApresentacao.set(Number(apresentacao.id), {
          status: apresentacao.status,
          motivo: apresentacao.pendencia,
          vinculo: apresentacao.vinculo
        })
      )
    );
    this.vinculos.forEach(vinculo => {
      vinculo.correspondencia = porApresentacao.get(Number(vinculo.id)) || {
        status: 'PENDENTE',
        motivo: catalogo && !catalogo.fornecimento
          ? 'A filial não possui uma fábrica fornecedora ativa.'
          : 'O de/para ainda não foi configurado.',
        vinculo: null
      };
    });
  }
}
